import React from 'react'
import DefaultUpload from './DefaultUpload'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'

import Data from 'EurestoClass/Data'
import Utils from 'EurestoFonction/Utils'
import Constants from 'EurestoFonction/Constants'

import Grid from '@material-ui/core/Grid'

export default class FileUpload extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      template: props.view || 'default'
    }
  }

  componentWillMount () {
    const typeFichier = Data.list(Constants.module.COMMUN, Constants.donnee.type_media)
    const typeOfFichier = typeFichier.filter(r => r.visible === 1)
    this.setState({
      typeFichier: typeOfFichier,
      allTypeFichier: typeFichier,
      key: Utils.getRandomNumber()
    })
  }

  render () {
    if (this.state.template !== 'default') {
      let file2send = this.state.allTypeFichier.find(r => r.abrege === this.state.template)
      return (
        <DefaultUpload
            catchedUploadFile={this.props.catchedUploadFile}
          type={this.props.type}
          style={this.props.style}
          avatarStyle={this.props.avatarStyle}
          disabled={this.props.disabled}
          handleUploaded={this.props.handleUpload}
          key={this.state.key}
          contact_id={this.props.contact_id}
          typeFichier={file2send}
          template={this.state.template}
          action={this.props.action}
          src={this.props.src}
        />
      )

    } else {
      let file2Send = this.state.typeFichier.find(r => r.libelle === this.state.value)
      return (
        <div className="example">
          {this.typeFichier()}
          {this.state.value !== undefined &&
          <DefaultUpload
              catchedUploadFile={this.props.catchedUploadFile}
            type={this.props.type}
            style={this.props.style}
            avatarStyle={this.props.avatarStyle}
            disabled={this.props.disabled}
            handleUploaded={this.props.handleUpload}
            key={this.state.key}
            contact_id={this.props.contact_id}
            typeFichier={file2Send}
            action={this.props.action}
            src={this.props.src}
          />}
        </div>

      )
    }
  }

  handleChange = event => {
    this.setState({value: event.target.value, key: Utils.getRandomNumber()})
  }

  typeFichier = () => {

    return (
      <Grid container>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="fichier_gender"
            name="fichier"
            value={this.state.value}
            onChange={this.handleChange}
            row>
            {
              this.state.typeFichier.map((typeOfFichier, k) => (
                <FormControlLabel key={k} control={<Radio
                  icon={<i className={'EurestoPrimary--text fa fa-' + typeOfFichier.checkedIcon}/>}
                  checkedIcon={<i className={'EurestoSecondary--text fa fa-' + typeOfFichier.checkedIcon}/>}/>}
                                  label={typeOfFichier.libelle} value={typeOfFichier.libelle}/>
              ))
            }
          </RadioGroup>
        </FormControl>
      </Grid>
    )
  }
}




// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Upload/ViewUpload.js